import * as React from 'react';
import { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

const TabsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Data for buttons and corresponding images
  const features = [
    {
      label: 'Cloud Map',
      image: '/images/cloud-map.png',
      description:
        'You have successfully mapped your cloud resources today. View the detailed visualization and insights in your CloudMap dashboard.',
    },
    {
      label: 'Secure Guard',
      image: '/images/secure-guard.png',
      description:
        'Secure Guard helps you monitor and protect your cloud environment with real-time alerts and advanced security analytics.',
    },
    {
      label: 'Compliance',
      image: '/images/compliance.png',
      description:
        'Stay compliant with industry standards and regulations using our comprehensive compliance tracking tools.',
    },
    {
      label: 'Defender Scan',
      image: '/images/defender-scan.png',
      description:
        'Defender Scan ensures your system’s integrity with periodic scans and detailed reporting.',
    },
    {
      label: 'Fin Ops',
      image: '/images/fin-ops.png',
      description:
        'Fin Ops provides you with the tools to track and optimize your cloud spending efficiently.',
    },
    {
      label: 'Command Center',
      image: '/images/command-center.png',
      description:
        'Command Center allows centralized management of all your cloud resources with powerful analytics.',
    },
    {
      label: 'Connected-Accounts',
      image: '/images/connected-accounts.png',
      description:
        'Easily manage and secure multiple connected accounts in a unified dashboard.',
    },
  ];

  return (
    <section style={{ backgroundColor: '#fff', padding: '40px 0' }} className='py-5'>
      <Container id='dashboard'>
        {/* Heading and Description */}
        <Row className="text-center mb-4">
          <Col>
            <h2 className='heading'>Smarter Scaling Starts Here</h2>
            <p className='description'>
                Discover tools to optimize, secure, and scale your cloud infrastructure effortlessly, ensuring efficiency, reliability,
                flexibility, scalability, and cost-effective cloud management solutions.
            </p>
          </Col>
        </Row>

        <Row>
          {/* Left Content Column (Image and Description) */}
          <Col md={9} xs={12} className='mt-4'>
            <img
              src={features[activeIndex].image}
              alt={features[activeIndex].label}
              style={{
                width: '100%',
                borderRadius: '8px',
                objectFit: 'cover',
              }}
            />
          </Col>

          {/* Right Buttons Column */}
          <Col md={3} className=''>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {features.map((feature, index) => (
                <Button className='tabs-btn shadow mt-2 text-center'
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  style={{
                    backgroundColor: activeIndex === index ? '#342ead' : '#fff',
                    color: activeIndex === index ? '#fff' : '#111',
                    border: 'none',
                    fontSize:"1.2rem",
                    borderRadius: '8px',
                    textAlign: 'left',
                    padding:"12px 20px",
                    fontWeight: activeIndex === index ? 'bold' : '500',
                    boxShadow: activeIndex === index ? 'shadow-sm' : 'none',
                  }}
                >
                  {feature.label}
                </Button>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TabsSection;
